'use client';

import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';

export function DocsFrame({ children }: { children: React.ReactNode }) {
  return (
    <BaseLayout
      sidebar={false}
      classNames={{
        content: 'max-w-none px-0 pt-4 lg:px-0 lg:pt-24 xl:px-0 xl:pt-24',
      }}
    >
      {children}
    </BaseLayout>
  );
}
